export default "__VITE_ASSET__DqTgtrY9__"